"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment TableModule on TableModule {\n    __typename\n    editorialContentType\n    id\n    title\n    description\n    columnDefinitions {\n      key\n      label\n    }\n    rows {\n      cells {\n        value {\n          text\n          textLinks {\n            id\n            title\n            relativeUrl\n          }\n        }\n        columnKey\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tableModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const tableModuleFragment = exports.tableModuleFragment = (0, _fetching.gql)(_templateObject());
